<div class="table-container">
    <aside class="locked">
        <table>
            <thead>
                <tr>
                    <th>{{'dashboard.datatables.byPartitions.partitions.shortLabel' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let kpi of kpisByYear[0].kpis">
                    <tr *ngIf="kpi.ratio?.isVisible || kpi.amount?.isVisible" class="deep-0">
                        <td>{{kpi.text?.fullLabel}}</td>
                    </tr>
                </ng-container>

                <ng-container *ngFor="let partition of partitions" class="deep-0">
                    <tr *ngIf="partition.partitionDetails.level === 1" class="deep-0">
                        <td>{{partition.partitionDetails.text?.fullLabel}}</td>
                    </tr>
                </ng-container>

                <ng-container *ngFor="let partition of partitions" class="deep-0">
                    <tr *ngIf="partition.isMainCursor" class="deep-0">
                        <td>{{partition.partitionDetails.text?.fullLabel}}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </aside>

    <section class="years-data">
        <table>
            <thead>
                <tr>
                    <th *ngFor="let kpiYear of kpisByYear">{{ kpiYear.year }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let kpi of kpisByYear[0].kpis; let i=index">
                    <tr *ngIf="kpi.ratio?.isVisible || kpi.amount?.isVisible" class="deep-0">
                        <td *ngFor="let kpiYear of kpisByYear" [ngClass]="{executed: !kpiYear.isEstimated}">
                            <span *ngIf="kpiYear.kpis[i].ratio?.isVisible">{{ kpiYear.kpis[i].ratio.value | formatPercent}}</span>
                            <span *ngIf="kpiYear.kpis[i].amount?.isVisible">{{ kpiYear.kpis[i].amount.value | formatAmount}}</span>
                        </td>
                    </tr>
                </ng-container>

                <ng-container *ngFor="let partition of partitions" class="deep-0">
                    <tr *ngIf="partition.partitionDetails.level === 1" class="deep-0">
                        <td *ngFor="let year of partition.simulationValues.years" [ngClass]="{executed: !year.isEstimated}">
                            <span class="amount">{{ year.amount | formatAmount }}</span>
                        </td>
                    </tr>
                </ng-container>

                <ng-container *ngFor="let partition of partitions" class="deep-0">
                    <tr *ngIf="partition.isMainCursor" class="deep-0">
                        <td *ngFor="let year of partition.simulationValues.years" [ngClass]="{executed: !year.isEstimated}">
                            <span class="amount">{{ year.amount | formatAmount }}</span>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </section>
</div>
